import { RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import CommonLoader from '@/components/CommonLoader';
import { useAuth } from '@/contexts/AuthContext';
import HomePage from '@/pages/public/LandingPage';
import { StatusUnavailable } from '@/pages/public/Status/Unavailable';

import { AuthRedirect } from './Authenticated';

const PublicFallback = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <CommonLoader isLoading={true} />;
  if (isAuthenticated) return <CommonLoader isLoading={true} />;

  return <Navigate to='/' replace />;
};

export const publicRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <AuthRedirect>
        <HomePage />
      </AuthRedirect>
    ),
  },
  {
    path: 'site-unavailable',
    element: <StatusUnavailable />,
  },
  {
    path: '*',
    element: <PublicFallback />,
  },
  // {
  //   path: 'callback',
  //   element: <Callback />,
  // },
  // {
  //   path: LOGIN_URL,
  //   element: (
  //     <AuthRedirect>
  //       <LoginCover />
  //     </AuthRedirect>
  //   ),
  // },
];
